import { shuffleArray } from '@/src/general/utils/shuffleArray'

import { INTENTION_TYPE } from '../models/Intention.enums'
import type { TTypeIntention } from '../models/Intention.types'

const maxIntentions = {
  [INTENTION_TYPE.INTENTION]: 3,
  [INTENTION_TYPE.ARRIVAL]: 1,
  [INTENTION_TYPE.BIRTHDAY]: 1,
}

type TIntentionSpot = { type: INTENTION_TYPE; index: number }

/** Get an array of max intention spots of type */
const getAllSpotsOfType = (type: INTENTION_TYPE): TIntentionSpot[] =>
  Array(maxIntentions[type])
    .fill(null)
    .map((_, index) => ({ type, index }))
/** Gather all the intention spots  */
const unshuffledSpots = Object.values(INTENTION_TYPE).flatMap(getAllSpotsOfType)
const shuffledSpots = shuffleArray(unshuffledSpots)

/**
 * Return the different intentions in the order defined by the shuffled spots
 *
 * Ex: if `shuffledSpots = [{ type: INTENTION_TYPE.INTENTION, index: 3 }, { type: INTENTION_TYPE.BIRTHDAY, index: 0 }, ... ]`,
 * then the result will be `[intentions[3], birthdayIntentions[0], ...]`
 */
export const getShuffledIntentions = (typeIntentions: {
  [Type in INTENTION_TYPE]: TTypeIntention<Type>[]
}): TTypeIntention[] => shuffledSpots.map(({ type, index }) => typeIntentions[type][index]).filter(Boolean)
